import type { ExportConfig, GeneratedFile, LanguageGenerator } from './types';
import { generateEnv } from './utils';

export const cGenerator: LanguageGenerator = {
  id: 'c',
  name: 'C',
  category: 'request-examples',
  color: '#A8B9CC',
  generate(config: ExportConfig): GeneratedFile[] {
    const lines: string[] = [
      '/* mail_requests.c — generated by Mail Service SDK Export */',
      '/* Requires: libcurl  (compile: gcc mail_requests.c -lcurl -o mail_requests) */',
      '#include <stdio.h>',
      '#include <stdlib.h>',
      '#include <string.h>',
      '#include <curl/curl.h>',
      '',
      'static size_t write_cb(void *ptr, size_t size, size_t n, void *buf) {',
      '    strncat((char *)buf, (char *)ptr, size * n);',
      '    return size * n;',
      '}',
      '',
      'static int mail_send(const char *url, const char *api_key, const char *body) {',
      '    CURL *curl = curl_easy_init();',
      '    if (!curl) return -1;',
      '    char resp[4096] = {0};',
      '    struct curl_slist *headers = NULL;',
      '    char key_header[256];',
      '    snprintf(key_header, sizeof(key_header), "X-API-KEY: %s", api_key);',
      '    headers = curl_slist_append(headers, "Content-Type: application/json");',
      '    headers = curl_slist_append(headers, key_header);',
      '    curl_easy_setopt(curl, CURLOPT_URL, url);',
      '    curl_easy_setopt(curl, CURLOPT_HTTPHEADER, headers);',
      '    curl_easy_setopt(curl, CURLOPT_POSTFIELDS, body);',
      '    curl_easy_setopt(curl, CURLOPT_WRITEFUNCTION, write_cb);',
      '    curl_easy_setopt(curl, CURLOPT_WRITEDATA, resp);',
      '    curl_easy_perform(curl);',
      '    printf("%s\\n", resp);',
      '    curl_slist_free_all(headers);',
      '    curl_easy_cleanup(curl);',
      '    return 0;',
      '}',
      '',
      'int main(void) {',
      `    const char *service_url = getenv("${config.serviceUrlVarName}");`,
    ];

    for (const app of config.apps) {
      lines.push(`    const char *${app.key}_key = getenv("${app.envVarName}");`);
    }
    lines.push('    char url[512];');
    lines.push('');

    for (const app of config.apps) {
      for (const t of app.templates) {
        const exampleData = t.schema
          ? t.schema.map((f) => `\\"${f.key}\\": \\"${f.example || f.key}\\"`).join(', ')
          : '';
        lines.push(`    /* Send: ${t.name} */`);
        lines.push(`    snprintf(url, sizeof(url), "%s/v1/send", service_url);`);
        lines.push(`    mail_send(url, ${app.key}_key,`);
        lines.push(`        "{\\"template_slug\\": \\"${t.slug}\\", \\"recipient\\": \\"user@example.com\\", \\"data\\": {${exampleData}}}");`);
        lines.push('');
      }
    }

    lines.push('    return 0;', '}');

    return [
      { filename: 'mail_requests.c', content: lines.join('\n'), syntax: 'c' },
      { filename: '.env', content: generateEnv(config), syntax: 'shell' },
    ];
  },
};
